type SvgProps = React.SVGProps<SVGSVGElement>;

export const GreenTickGreenCircleGradient = (props: SvgProps) => (
  <svg
    {...props}
    width="47"
    height="47"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="22" cy="22" r="22" fill="#70FC90" fill-opacity="0.15" />
    <rect
      x="3.475"
      y="3.475"
      width="37.05"
      height="37.05"
      rx="18.525"
      fill="#E5F7E3"
    />
    <rect
      x="3.475"
      y="3.475"
      width="37.05"
      height="37.05"
      rx="18.525"
      stroke="url(#paint0_linear_702_3384)"
      stroke-width="0.95"
    />
    <g clip-path="url(#clip0_702_3384)">
      <path
        d="M25.4026 19.0613L26.5141 20.1895L21.928 24.7075C21.6216 25.0139 21.2186 25.1667 20.8141 25.1667C20.4095 25.1667 20.0026 25.0123 19.6931 24.7035L17.4907 22.5692L18.5935 21.4316L20.8046 23.5746L25.4026 19.0613ZM31.5 22C31.5 27.2385 27.2385 31.5 22 31.5C16.7615 31.5 12.5 27.2385 12.5 22C12.5 16.7615 16.7615 12.5 22 12.5C27.2385 12.5 31.5 16.7615 31.5 22ZM29.9167 22C29.9167 17.6348 26.3653 14.0833 22 14.0833C17.6348 14.0833 14.0833 17.6348 14.0833 22C14.0833 26.3653 17.6348 29.9167 22 29.9167C26.3653 29.9167 29.9167 26.3653 29.9167 22Z"
        fill="#24843F"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_702_3384"
        x1="22"
        y1="3"
        x2="22"
        y2="41"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7BCE89" />
        <stop offset="1" stop-color="#51A56F" stop-opacity="0.06" />
      </linearGradient>
      <clipPath id="clip0_702_3384">
        <rect
          width="19"
          height="19"
          fill="white"
          transform="translate(12.5 12.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
